<template>
    <summary-bar class="filter-bar"
                 root-class="filter-bar"
                 text="Filters"
                 :flyout-open="flyoutOpen"
                 @click="$emit('click')">
        <div class="filter-bar__active-filters">
            <i :class="`filter-bar__active-filters__icon fas fa-star --recommended${this.filters.recommended ? ' --shown' : ''}`" />
            <i :class="`filter-bar__active-filters__icon fas fa-check --in-plan${this.filters.selected ? ' --shown' : ''}`" />
        </div>
    </summary-bar>
</template>

<script>

import Vuex from 'vuex'

import SummaryBar from './summary-bar'

export default {

    props: {
        flyoutOpen: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {ImprovementsVuexStateFilters}
             */
            filters: stateStore => stateStore.improvements.improvementFilters,
        }),
    },

    components: {
        SummaryBar,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_filter-bar.scss

.filter-bar {

    @include element('active-filters') {
        position: absolute;
        right: rem(7px);
        display: inline-block;
        text-align: right;

        @include element('icon') {
            display: none;
            margin-left: rem(7px);
            position: relative;
            bottom: rem(1px);

            &.--shown {
                display: inline-block;
            }
        }
    }
}

</style>
